import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FontFamily, FontSize } from "config/font";
import { MonthlyOverview } from "./monthlyOverview.component";
import { UnhandledOverview } from "./unhandledOverview.component";

import { StyledTabGroup } from "./timeReports.styled";
import { TabStyled } from "../tab/tab.styled";
import { Text } from "components/Typography/text.styled";
import { useTimeReportStore } from "web-apps/company/stores/timeReportStore/timeReportStore";
import { PersonnelCarrierOverview } from "./personnelCarrierOverview.component";

const TIME_REPORTS_TAB = {
  filtered: "Filtered",
  all: "All",
  personnelCarrier: "PersonnelCarrier",
} as const;

type TimeReportsTab =
  (typeof TIME_REPORTS_TAB)[keyof typeof TIME_REPORTS_TAB];

export const TimeReports: React.FC = () => {
  const [currentTab, setCurrentTab] = useState<TimeReportsTab>(
    TIME_REPORTS_TAB.filtered,
  );
  const [timeReportState] = useTimeReportStore();
  const { t } = useTranslation();

  return (
    <>
      <StyledTabGroup>
        <TabStyled
          active={currentTab === TIME_REPORTS_TAB.filtered}
          onClick={() => setCurrentTab(TIME_REPORTS_TAB.filtered)}
        >
          <Text
            fontFamily={FontFamily.MontserratSemiBold}
            fontSize={FontSize.Large}
          >
            {t("CompanyTimeReport.UnhandledTimeReports")} (
            {timeReportState.unhandledTimeReportCount})
          </Text>
        </TabStyled>
        <TabStyled
          active={currentTab === TIME_REPORTS_TAB.all}
          onClick={() => setCurrentTab(TIME_REPORTS_TAB.all)}
        >
          <Text
            fontFamily={FontFamily.MontserratSemiBold}
            fontSize={FontSize.Large}
          >
            {t("CompanyTimeReport.AllTimeReports")}
          </Text>
        </TabStyled>
        <TabStyled
          active={currentTab === TIME_REPORTS_TAB.personnelCarrier}
          onClick={() => setCurrentTab(TIME_REPORTS_TAB.personnelCarrier)}
        >
          <Text
            fontFamily={FontFamily.MontserratSemiBold}
            fontSize={FontSize.Large}
          >
            {t("CompanyTimeReport.PersonnelCarrier")}
          </Text>
        </TabStyled>
      </StyledTabGroup>

      {currentTab === TIME_REPORTS_TAB.filtered && <UnhandledOverview />}
      {currentTab === TIME_REPORTS_TAB.all && <MonthlyOverview />}
      {currentTab === TIME_REPORTS_TAB.personnelCarrier && (
        <PersonnelCarrierOverview />
      )}
    </>
  );
};
